import React, { useEffect } from 'react';
import { FileError } from 'react-dropzone';
import { useTranslation } from 'react-i18next';
import { AppButton, Preloader } from '@common-fe/common-fe';

import useUploadDropzone from '@/components/controls/DropScan/hooks/useUploadDropzone';

interface Props {
  onUpload?: () => void;
  onFileUploadError?: (error?: FileError) => void;
  onLoadingChange?: (isLoading: boolean) => void;
  style?: React.CSSProperties;
  storeKey?: string;
  multiple?: boolean;
  isFileLoading?: boolean;
  maxFiles?: number;
  testId?: string;
  children?: React.ReactNode;
  width?: string;
  disableFilesUpload?: boolean;
  ocrRequired?: boolean;
}

const UploadButton: React.FC<Props> = ({
  onUpload,
  onFileUploadError,
  onLoadingChange,
  isFileLoading,
  style,
  storeKey,
  children,
  testId,
  multiple,
  maxFiles,
  width,
  disableFilesUpload = true,
  ocrRequired = false,
}) => {
  const { t } = useTranslation();

  const { open, getInputProps, isLoading } = useUploadDropzone({
    onUpload,
    onFileUploadError,
    storeKey,
    multiple,
    maxFiles,
    disableFilesUpload,
    ocrRequired,
  });

  useEffect(() => {
    onLoadingChange?.(isLoading);
  }, [isLoading, onLoadingChange]);

  return (
    <>
      <AppButton
        testId={testId}
        onClick={open}
        buttonType="primary"
        style={{ minWidth: '120px', ...style }}
        width={width}
        disabled={isLoading || isFileLoading}
      >
        {isLoading || isFileLoading ? (
          <Preloader testId="upload-button_preloader" color="white" />
        ) : (
          children || t('Upload')
        )}
      </AppButton>

      <input {...getInputProps()} />
    </>
  );
};

export default UploadButton;
